var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _vm.device === "mobile" && _vm.sidebar.opened
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside },
          })
        : _vm._e(),
      _c("HocHeader"),
      _c("GoodsGlobalSearch"),
      _c("BalanceDaysWarningDialog", {
        attrs: {
          visible: _vm.balanceWarningVisible,
          detail: _vm.balanceWarningDetail,
        },
        on: {
          close: function ($event) {
            _vm.balanceWarningVisible = false
          },
        },
      }),
      _c(
        "div",
        {
          staticClass: "main-container",
          class: { hasTagsView: _vm.needTagsView },
        },
        [
          _c("sidebar", { staticClass: "sidebar-container" }),
          _c("app-main"),
          _vm.showSettings ? _c("right-panel", [_c("settings")], 1) : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }